module.exports = __webpack_public_path__ + "static/media/manny_wave.edd16dd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/manny_wave.svg
// module id = 188
// module chunks = 0